import React from 'react';
import type { PlanContext } from '../../api/plan';
import { INTERFACE_TEXT } from '../../constants/interfaceText';
import { fill, marksFor } from '../../today/todayViewModel';
import styles from './Browse.module.css';

/** One bar per lesson and a dot for the check-in. Marks only: no totals or scores (C-02). */
export const ProgressMarks: React.FC<{ context: PlanContext }> = ({
  context,
}) => {
  const marks = marksFor(context);
  const done = marks.lessons.filter(Boolean).length;
  const label = fill(INTERFACE_TEXT.tdMarksLabel, {
    done,
    total: marks.lessons.length,
    check: marks.checkIn
      ? INTERFACE_TEXT.tdMarksCheckPassed
      : INTERFACE_TEXT.tdMarksCheckOpen,
  });
  return (
    <span className={styles.marks} role="img" aria-label={label}>
      {marks.lessons.map((isDone, i) => (
        <i key={i} className={isDone ? styles.markDone : styles.mark} />
      ))}
      <i className={marks.checkIn ? styles.checkDone : styles.check} />
    </span>
  );
};

export default ProgressMarks;
